var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hot-meta-wrapper"},[(_vm.ready)?_c('hot',{ref:"hot",attrs:{"settings":_vm.settings,"data":_vm.tableData}}):_c('bl-loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }